import lazyLoading from './lazyLoading'

export default {
  name: 'admin',
  meta: {
    expanded: false,
    title: 'Programación',
    iconClass: 'vuestic-icon vuestic-icon-settings'
  },
  children: [
    {
      name: 'debits',
      path: '/debits',
      component: lazyLoading('app/debits/Main'),
      meta: {
        title: 'Adeudos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/debits/List'),
          meta: {
            title: 'Adeudos'
          }
        },
        {
          path: ':debitId',
          component: lazyLoading('app/debits/View'),
          props: true,
          meta: {
            title: 'Adeudo'
          },
        },
        {
          path: 'edit/:debitId',
          component: lazyLoading('app/debits/Edit'),
          props: true,
          meta: {
            title: 'Adeudo'
          },
        },
      ]
    },
    {
      name: 'refunds',
      path: '/refunds',
      component: lazyLoading('app/refunds/Main'),
      meta: {
        title: 'Reembolsos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/refunds/List'),
          meta: {
            title: 'Reembolsos'
          }
        },
      ]
    },
    {
      name: 'configSellers',
      path: '/config-sellers',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Vendedores'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/SellersList'),
          meta: {
            title: 'Vendedores'
          }
        },
        {
          path: ':sellerId',
          component: lazyLoading('config/SellerView'),
          props: true,
          meta: {
            title: 'Vendedores'
          }
        },
        {
          path: 'new',
          component: lazyLoading('config/SellerView'),
          props: true,
          meta: {
            title: 'Vendedores'
          }
        }
      ]
    },
    {
      name: 'allTicketList',
      path: '/trips/all-ticket-list',
      component: lazyLoading('trips/TicketList'),
      meta: {
        title: 'Boletos Físicos',
        requiresAuth: true
      }
    },
    {
      name: 'errorsServer',
      path: '/tools/error-list',
      component: lazyLoading('config/ErrorList'),
      meta: {
        title: 'Errores',
        requiresAuth: true
      }
    },
    {
      name: 'configCampaing',
      path: '/config-campaing',
      component: lazyLoading('config/Main'),
      props: true,
      meta: {
        title: 'Campaña'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/CampaingList'),
          props: true,
          meta: {
            title: 'Campaña'
          }
        },
        {
          path: 'new',
          component: lazyLoading('config/CampaingView'),
          props: true,
          meta: {
            title: 'Campaña'
          }
        },
        {
          path: ':campaingId',
          component: lazyLoading('config/CampaingView'),
          props: true,
          meta: {
            title: 'Campaña'
          },
        },
        {
          path: ':campaingId/:promoId',
          component: lazyLoading('config/PromoView'),
          props: true,
          meta: {
            title: 'Campaña'
          },
        },
      ]
    },
    {
      name: 'configSubzone',
      path: '/config-subzone',
      component: lazyLoading('config/Main'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/SubZoneList'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          name: 'SubZoneNew',
          path: 'new/:zoneId', // Default route
          component: lazyLoading('config/SubZoneView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          name: 'SubZoneView',
          path: ':subzoneId',
          component: lazyLoading('config/SubZoneView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          },
        },
      ],
    },
    {
      name: 'configZone',
      path: '/config-zone',
      component: lazyLoading('config/Main'),
      props: true,
      meta: {
        title: 'Zonas'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ZoneList'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/ZoneView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          name: 'ZoneView',
          path: ':zoneId',
          component: lazyLoading('config/ZoneView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          },
        },
      ],
    },
    {
      name: 'configPrice',
      path: '/config-price',
      component: lazyLoading('config/Main'),
      props: true,
      meta: {
        title: 'Precios'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/PriceList'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/PriceView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          name: 'ZoneView',
          path: ':zoneId',
          component: lazyLoading('config/PriceView'),
          props: true,
          meta: {
            title: 'Sub Zonas'
          },
        },
      ],
    },
    {
      name: 'aircabSalesAdminV1',
      path: '/financial/aircab-sales-admin-v1',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/AircabList'),
          meta: {
            title: 'Lista Aircab'
          }
        }
      ]
    },
    {
      name: 'aircabScheduledSales',
      path: '/financial/aircab-scheduled-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Vuelta Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/AircabScheduledList'),
          meta: {
            title: 'Lista Vuelta Aircab'
          }
        }
      ]
    },
    {
      name: 'ticketScheduled',
      path: '/financial/ticket-scheduled',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Ticket Retorno Asignados'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/TicketScheduledList'),
          meta: {
            title: 'Ticket Retorno Asignados'
          }
        }
      ]
    },
    {
      name: 'dailySales',
      path: '/financial/daily-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Cortes'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/DailySalesList'),
          meta: {
            title: 'Corte'
          }
        },
        {
          path: ':dailySaleId',
          component: lazyLoading('financial/DailySalesDetail'),
          props: true,
          meta: {
            title: 'Detalle del corte'
          }
        }
      ]
    },
    {
      name: 'processDay',
      path: '/utils/process-day',
      component: lazyLoading('tools/ProcessDay'),
      meta: {
        title: 'Proceso del Día',
        requiresAuth: true
      }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/admin.js